import { useContext } from 'react';

import { ChainContext } from '../chain.context';
import { Chain } from '../types';

export const useChain = (): Chain | null => {
  const context = useContext(ChainContext);
  if (!context) {
    throw new Error('useChain must be used within a ChainProvider');
  }

  return context.chain;
};
